import { useCallback } from 'react'

import {
  calcDesignDownloadParams,
  calcDownloadParams,
  calcMarketSimulatorDownloadParams
} from '@aytm/app/stats/page/question-views/cjc/lib/export-params'

// The export handlers both conjoint blocks hand to their head and their market simulator. Each
// one resolves the whole download-service payload here and passes it to the block, which only
// runs the download.
export default function useConjointExport({
  state,
  answer,
  batches,
  designSheet,
  link,
  position,
  questionId,
  questionKey,
  questionType,
  visualPosition,
  onExport,
  onDesignExport,
  onMarketSimulatorExport
}) {
  const onHeadExport = useCallback(
    ({ fileType, exportType, exportMethod }, callback) => {
      if ('conjointDesign' === exportType) {
        const params = calcDesignDownloadParams({ batches, designSheet, link, visualPosition })

        onDesignExport?.(params.position, params.params, params.designSheet, callback)
        return
      }

      const download = calcDownloadParams({
        fileType,
        exportType,
        exportMethod,
        questionId,
        link,
        position,
        mode: state.mode,
        persona: state.persona
      })

      onExport?.(download.fileType, download.exportType, download.exportOptions, callback)
    },
    [
      batches,
      designSheet,
      link,
      position,
      questionId,
      state.mode,
      state.persona,
      visualPosition,
      onDesignExport,
      onExport
    ]
  )

  const onSimulatorExport = useCallback(
    ({ fileType, exportType }, callback) => {
      const download = calcMarketSimulatorDownloadParams({
        fileType,
        exportType,
        questionType,
        questionKey,
        answer,
        batches,
        link,
        visualPosition,
        persona: state.persona,
        marketSimulatorPackages: state.storedMarketSimulatorPackages,
        marketSimulatorNA: state.marketSimulatorNA
      })

      onMarketSimulatorExport?.(download.fileType, download.exportType, download.exportOptions, callback)
    },
    [
      answer,
      batches,
      link,
      questionKey,
      questionType,
      state.marketSimulatorNA,
      state.persona,
      state.storedMarketSimulatorPackages,
      visualPosition,
      onMarketSimulatorExport
    ]
  )

  return { onHeadExport, onSimulatorExport }
}
